import { Response } from '@angular/http';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/of';
import { QuoteOverviewModel } from './models/interpretation.model';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { catchError } from 'rxjs/operators';

@Injectable()
export class QuoteService {
  quotes$: BehaviorSubject<QuoteOverviewModel[]> = new BehaviorSubject<QuoteOverviewModel[]>([]);
  quotes: QuoteOverviewModel[];
  loadedAtLeastOnce: boolean = false;

  constructor(private _http: HttpClient) {
    this.quotes$.next([]);
  }

  public getQuoteOverviews(): Observable<QuoteOverviewModel[]> {
    return this.quotes$.asObservable();
  }

  public getQuoteOverviewsAndReloadIfFirst(inspectionId: number): Observable<QuoteOverviewModel[]> {
    if (!this.loadedAtLeastOnce)
      this.reloadQuoteOverview(inspectionId);
    return this.quotes$.asObservable();
  }

  reloadQuoteOverview(inspectionId: number) {
    this.getQuoteOverviewsHttp(inspectionId).subscribe(r => {
      this.quotes$.next(r);
      this.loadedAtLeastOnce = true;
    });
  }

  public getQuoteOverviewsHttp(inspectionId: number): Observable<QuoteOverviewModel[]> {
    let options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString())
    };
    return this._http.get<QuoteOverviewModel[]>("api/interpretation/getquoteoverviews", options).pipe(catchError(this.handleError));
  }

  public CheckInspectionHasBeenReleasedYet(inspectionId : number, quoteReportId : number): Observable<any>{
    let options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString()).set('quoteReportId',quoteReportId.toString())
    };
    return this._http.get("api/interpretation/CheckInspectionHasBeenReleasedYet", options).pipe(catchError(this.handleError));
  }

  public downloadQuotePDF(inspectionId: number, quoteId: number) {
    return this._http.post(
      "api/Interpretation/DownloadQuotePDF",
      {
        Inspectionid: inspectionId,
        quoteId: quoteId
      },
      {
        responseType: 'blob',
        observe: 'response'  }
    );
  }

  private handleError(error: Response) {
    console.error(error);
    return Observable.throw(error.json().error || 'Server error');
  }
}
